import React from 'react'
import { HeaderEl } from './elements'
import { Button } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import { useHistory, useParams } from 'react-router-dom'

const Header = () => {
  const { courseURL, livDemyID } = useParams()
  const history = useHistory()

  return (
    <HeaderEl>
      <Button
        onClick={() => history.push(`/${livDemyID}/course/${courseURL}`)}
        startIcon={<ArrowBackIosIcon />}
      >
        Back
      </Button>
    </HeaderEl>
  )
}

export default Header
